export const estadisticasConsumoService = {
  async getEstadisticasConsumo(token = null, mesDesde = null, añoDesde = null, mesHasta = null, añoHasta = null) {
    try {
      // Obtener el token del localStorage si no se proporciona como parámetro
      const authToken = token || localStorage.getItem('token');

      if (!authToken) {
        throw new Error('No hay token de autenticación');
      }

      // Construir la URL con parámetros de mes y año si se proporcionan
      let url = '/api/dashboard/estadisticas-consumo';
      if (mesDesde && añoDesde && mesHasta && añoHasta) {
        url += `?mesDesde=${mesDesde}&añoDesde=${añoDesde}&mesHasta=${mesHasta}&añoHasta=${añoHasta}`;
      }

      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Token expirado o inválido');
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log('📊 [Estadísticas Consumo] Datos completos recibidos:', data);

      // Extraer las estadísticas de consumo, el límite y conversaciones contratadas
      if (data.data && Array.isArray(data.data)) {
        console.log('📈 [Estadísticas Consumo] Datos extraídos:', data.data.serie);
        console.log('🔢 [Estadísticas Consumo] Límite del servidor:', data.data.limite);
        console.log('📊 [Estadísticas Consumo] Conversaciones contratadas:', data.data.conversacionesContratadas);
        console.log('📊 [Estadísticas Consumo] Plan compartido:', data.data.planCompartido);
        return {
          serie: data.data[0].serie,
          limite: data.data[0].limite || 300, // Valor por defecto si no viene el límite
          conversacionesContratadas: data.data[0].conversacionesContratadas || 0, // Valor por defecto si no viene
          planCompartido: data.data[0].planCompartido || false
        };
      } else {
        throw new Error('Estructura de datos inesperada en la respuesta de la API');
      }
    } catch (error) {
      console.error('Error al obtener estadísticas de consumo:', error);
      throw error;
    }
  },

  async saveLimit(token = null, limit) {
    try {
      // Obtener el token del localStorage si no se proporciona como parámetro
      const authToken = token || localStorage.getItem('token');

      if (!authToken) {
        throw new Error('No hay token de autenticación');
      }

      if (!limit || limit < 0) {
        throw new Error('El límite debe ser un número positivo');
      }

      const response = await fetch('/api/dashboard/estadisticas-consumo/save-limit', {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          limite: limit
        })
      });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Token expirado o inválido');
        }
        if (response.status === 400) {
          throw new Error('Datos inválidos enviados');
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ [Estadísticas Consumo] Límite guardado exitosamente:', data);
      
      return data;
    } catch (error) {
      console.error('Error al guardar el límite:', error);
      throw error;
    }
  }
};
